import { render, staticRenderFns } from "./DownLoadApp.vue?vue&type=template&id=3cb4cb83&scoped=true"
import script from "./DownLoadApp.vue?vue&type=script&lang=js"
export * from "./DownLoadApp.vue?vue&type=script&lang=js"
import style0 from "./DownLoadApp.vue?vue&type=style&index=0&id=3cb4cb83&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb4cb83",
  null
  
)

export default component.exports